import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Text from 'components/common/Text/Text'
import Columns from 'components/common/Columns/Columns'

const StoreHolidays = ({ holidayName, weekDay, value, date }) =>
  <Wrapper data-at-store-holidays >
    <Columns width="60% 40%">
      <DateColumn>
        { holidayName && <HolidayText inline bolder>{ holidayName }</HolidayText> }
        <Text inline>{date}</Text>
      </DateColumn>
      <DateColumn>
        <Text inline>{value}</Text>
      </DateColumn>
    </Columns>
  </Wrapper>

export default StoreHolidays

StoreHolidays.propTypes = {
  date: PropTypes.string,
  holidayName: PropTypes.string,
  value: PropTypes.string,
  weekDay: PropTypes.string
}

const Wrapper = styled.div`
  & + & {
    padding-top: 5px;
  }
`

const HolidayText = styled(Text)`
  margin-right: 5px;
`

const DateColumn = styled.div`
  white-space: nowrap;
`

